class PedagogicalEditorController {
    constructor(pedagogicalService, $mdDialog) {
        const self = this;
        self.staticParameters = [
            { parameter: "Passive - Active" },
            { parameter: "Rehearse - Construct" },
            { parameter: "Linear - Non-linear/Creative" },
            { parameter: "Fixed challenges - Optimize Challenges" },
            { parameter: "Individual - Collaborative" },
            { parameter: "No assessment - Embedded assessment" },
        ];

        this.getParameters = () => {
            pedagogicalService.getAllParameters().then((data) => {
                self.parameters = data;
                console.log(data, "data from pedagogical");
                if (self.currentParameter) {
                    self.currentParameter = self.parameters.find(
                        (x) => x.parameter === self.currentParameter.parameter
                    );
                    self.currentParameter.questionsArray = Object.keys(
                        self.currentParameter.questions
                    ).map((key) => self.currentParameter.questions[key]);
                }
            });
        };

        this.selectParameter = (parameter) => {
            self.currentParameter = parameter;
            self.currentParameter.questionsArray = Object.keys(
                self.currentParameter.questions
            ).map((key) => self.currentParameter.questions[key]);

            self.currentParameterSplited = parameter.parameter.split(" - ");
        };

        this.addNewQuestionPrompt = () => {
            $mdDialog
                .show({
                    clickOutsideToClose: true,
                    templateUrl: "newQuestionPedag.tmpl.html",
                    parent: angular.element(document.body),
                    multiple: true,
                    local: self.currentParameterSplited,
                    controller: function DialogController($scope, $mdDialog) {
                        $scope.currentParameterSplited =
                            self.currentParameterSplited;
                        $scope.closeDialog = () => {
                            $mdDialog.cancel();
                        };
                        $scope.saveNewQuestion = (result, form) => {
                            if (form.$valid) {
                                $mdDialog.hide(result);
                            }
                        };
                    },
                })
                .then(
                    (questionData) => {
                        self.saveQuestion(questionData);
                    },
                    () => {}
                );
        };

        this.saveQuestion = (parameter) => {
            parameter = { ...parameter };
            parameter.parameter = self.currentParameter.parameter;
            pedagogicalService.updateQuestion(parameter).then(() => {
                self.getParameters();
            });
        };

        this.removeQuestion = (question) => {
            $mdDialog
                .show(
                    $mdDialog.confirm({
                        title: "Warning",
                        textContent:
                            "Are you sure you want to delete this question?",
                        ok: "OK",
                        cancel: "Cancel",
                        multiple: true,
                    })
                )
                .then(
                    () => {
                        pedagogicalService.removeQuestion(question).then(() => {
                            self.getParameters();
                        });
                    },
                    () => false
                );
        };

        this.getParameters();
    }
}

export default PedagogicalEditorController;



// WEBPACK FOOTER //
// ./src/app/pages/manageSkills/pedagogical/pedagogicalEditorController.js